export const RANGE_OPTIONS = [
  { name: "Custom Range", value: "custom" },
  { name: "Specific Date", value: "date" },
  { name: "This Month", value: "month" },
  { name: "This Year", value: "year" },
];

export function toDateInputValue(date) {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function computeDateRange(rangeMode, today, singleDate, dateRange) {
  if (rangeMode === "date") {
    const d = toDateInputValue(singleDate);
    return { startDate: d, endDate: d };
  }
  if (rangeMode === "month") {
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return { startDate: toDateInputValue(start), endDate: toDateInputValue(end) };
  }
  if (rangeMode === "year") {
    const start = new Date(today.getFullYear(), 0, 1);
    const end = new Date(today.getFullYear(), 11, 31);
    return { startDate: toDateInputValue(start), endDate: toDateInputValue(end) };
  }
  return {
    startDate: toDateInputValue(dateRange?.[0]),
    endDate: toDateInputValue(dateRange?.[1] || dateRange?.[0]),
  };
}
